// extracted by mini-css-extract-plugin
export default {"boardItem":"BoardItem_boardItem__0UzGQ"};